import Crud from '@/stores/crudBase';
import api from '@/apis/opening/openingAccountEntryStatisticAPI.js';
var crud = new Crud('openingAccountEntryStatistic', api);

const state = {
  ...crud.state,
  _config: {
    table: 'opening_account_entry_statistic',
    field: {
      code: 'stattistic_code',
      key: 'ref_detail_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
